import React, { Component } from 'react'
import {connect} from 'react-redux'
import style from './style.css';
import withMedia from '../../../containers/withmedia';
import * as Actions from '../../../store/reducers'
import { Link } from 'react-router-dom';
import jump from 'jump.js'

class ScrollingExperiences extends Component {

    constructor(props){
        super(props)
        this.state = { is_loading: false, highlights: null}
    }
    componentWillMount() {
      const { is_loading } = this.state 
      if(!is_loading){
        this.props.dispatch(Actions.getHighlights())
      }
    }
    render() {
        const is_large = this.props.browser.greaterThan.medium
        const item_width = is_large ? 270 : 240;
        const cards = this.props.highlights.slice(1,11)
        const scroll_width = (11 * (item_width + 10)) + 14 
        const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
        let slides = []
        slides = cards 
            ? cards.map( (node) => 
                <div key={node.id} className={ `${style.slide}` } style={{ width: item_width , height: "370px"}} >
                    <CardItem card={node} />
                </div>
                ) 
            : <div></div>;
        return (
            <div className={ style.experiences }>
                <h2 className={ style.title }  onClick={ () => { if(window.pageYOffset < 200){ jump(windowHeight - 150) } }}>إقرأ فى هذا العدد</h2>
                <div className={ style.scroller }>
                    <div style={{ width: `${scroll_width}px`, height: '390px'}} >
                        {slides}
        </div>
                </div>
            </div>
        )
    }
}
const CardItem = ({card}) => {
    const photo = card.photo_uri
    return (
      <Link to={`/posts/${card.id}`} className={ style.innerSlide }>
            <div className={ style.ribbon }>
                <span className={ style.t }>{ card.title }</span>
            </div>
            <div className={ style.img } style={ { backgroundImage: `url('${card.photo_uri}')` }}  > </div>
        </Link>
    )
}
//<div  href="/" className={ style.slideTitle}><span className={ style.uptitle }>{ t1 }</span><span className={ style.subtitle }>{ card.short }</span></div>

export default withMedia(connect(s => ({ highlights: s.app.highlights }))(ScrollingExperiences))



// WEBPACK FOOTER //
// ./src/components/homescreen/scrollingexperiences/index.js